// extracted by mini-css-extract-plugin
module.exports = {"primary":"#006def","theme":"#006def"};